import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Transition as _Transition, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_3 = { class: "inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-6xl sm:w-full sm:p-4" }
const _hoisted_4 = { class: "mt-2 text-left sm:mt-5" }
const _hoisted_5 = { class: "flex justify-between" }
const _hoisted_6 = { class: "mt-2 pb-2 text-left" }
const _hoisted_7 = { class: "mt-1 w-full overflow-x-auto" }

import { computed, onMounted, ref, watchEffect } from "vue";
import {
  Dialog,
  DialogTitle,
  DialogOverlay,
  TransitionRoot,
  TransitionChild,
} from "@headlessui/vue";

import DataTable from "@/components/tools/DataTable.vue";
import { formatNumber, translate } from "@/utils/tools";


export default /*#__PURE__*/_defineComponent({
  __name: 'AffiliateDetailTableDialog',
  props: { dataRows: Object, show: Boolean },
  emits: ["submit", "update:show", "update:form"],
  setup(__props, { emit }) {

const props = __props

const columns = [
  {
    label: translate("messages.affiliateSummary.level"),
    field: "level",
  },
  {
    label: translate("messages.affiliateSummary.betAmount"),
    field: "bet_amount",
    align: "center",
    format: (data: any) => formatNumber(data.bet_amount),
  },
  {
    label: translate("messages.affiliateSummary.settleAmount"),
    field: "settle_amount",
    align: "center",
    format: (data: any) => formatNumber(data.settle_amount),
  },
  {
    label: translate("messages.affiliateSummary.affiliateWinloss"),
    field: "affiliate_winloss",
    align: "center",
    format: (data: any) => formatNumber(data.affiliate_winloss),
  },
  {
    label: translate("messages.affiliateSummary.affiliateAmount"),
    field: "affiliate_amount",
    align: "center",
    format: (data: any) => formatNumber(data.affiliate_amount),
  },
  {
    label: translate("messages.affiliateSummary.carry_amount"),
    field: "carry_amount",
    align: "center",
    format: (data: any) => formatNumber(data.carry_amount),
  },
];

const showSync = computed({
  get: () => props.show,
  set: (value) => emit("update:show", value),
});

const convertData = (data: Object) => {
  const objectData = Object.values(data).map((dataSummary, index) => ({
      ...dataSummary,
      level: index + 1,
  }))
  return objectData
};

const sortByKey = (obj: any) => {
  const keys = Object.keys(obj);
  keys.sort();
  const sorted: any = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    sorted[key] = obj[key];
  }
  return sorted;
};





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    as: "template",
    show: _unref(showSync)
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        as: "div",
        static: "",
        class: "fixed z-10 inset-0 overflow-y-auto",
        onClose: _cache[1] || (_cache[1] = ($event: any) => (showSync.value = false)),
        open: _unref(showSync)
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogOverlay), { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
              ]),
              _: 1
            }),
            _hoisted_2,
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
              "enter-to": "opacity-100 translate-y-0 sm:scale-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100 translate-y-0 sm:scale-100",
              "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_Transition, {
                    "leave-active-class": "transition duration-100 ease-in",
                    "leave-from-class": "opacity-100",
                    "leave-to-class": "opacity-0"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("div", _hoisted_5, [
                            _createVNode(_unref(DialogTitle), {
                              as: "h3",
                              class: "text-lg leading-6 font-medium text-gray-900"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("messages.affiliateSummary.affiliateDetails")), 1)
                              ]),
                              _: 1
                            }),
                            _createElementVNode("button", {
                              class: "mr-md",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (showSync.value = false))
                            }, "x")
                          ]),
                          _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                              _createVNode(DataTable, {
                                columns: columns,
                                data: convertData(sortByKey(__props.dataRows?.data || __props.dataRows))
                              }, null, 8, ["data"])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["open"])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})